//#region src/guest_receipt_text_size.ts
let GuestReceiptTextSize = /* @__PURE__ */ function(GuestReceiptTextSize) {
	GuestReceiptTextSize["Small"] = "small";
	GuestReceiptTextSize["Medium"] = "medium";
	GuestReceiptTextSize["Large"] = "large";
	return GuestReceiptTextSize;
}({});
//#endregion
export { GuestReceiptTextSize };

//# sourceMappingURL=guest_receipt_text_size.js.map